import { combineReducers } from '@reduxjs/toolkit';
import { reducer as allSubstitutionsApiReducer } from './model/substitutions';
import { reducer as divisionReducer } from './model/divisions';

export * as SubstitutionsModel from './model';
export * as SubstitutionsUi from './ui';

const substitutionsReducer = combineReducers({
  substitutions: allSubstitutionsApiReducer,
  divisions: divisionReducer,
});

export default substitutionsReducer;
